import { render, staticRenderFns } from "./data_1c.vue?vue&type=template&id=77a254f0&scoped=true&"
import script from "./data_1c.vue?vue&type=script&lang=js&"
export * from "./data_1c.vue?vue&type=script&lang=js&"
import style0 from "./data_1c.vue?vue&type=style&index=0&id=77a254f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a254f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77a254f0')) {
      api.createRecord('77a254f0', component.options)
    } else {
      api.reload('77a254f0', component.options)
    }
    module.hot.accept("./data_1c.vue?vue&type=template&id=77a254f0&scoped=true&", function () {
      api.rerender('77a254f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/land/tabs/data_1c.vue"
export default component.exports